import { render, staticRenderFns } from "./StaticContentsTerms.vue?vue&type=template&id=5049985c&scoped=true&"
import script from "./StaticContentsTerms.vue?vue&type=script&lang=js&"
export * from "./StaticContentsTerms.vue?vue&type=script&lang=js&"
import style0 from "./StaticContentsTerms.vue?vue&type=style&index=0&id=5049985c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5049985c",
  null
  
)

export default component.exports